import type { ReactElement } from 'react';

import { PdfTextBlock, type PdfTextBlockProps } from '../../components/PdfTextBlock';

type PdfSpacerProps = {
  height: '0.5in' | '0.25in' | '0.1in';
  textBlockProps?: PdfTextBlockProps;
};

export const PdfSpacer = ({ height, textBlockProps }: PdfSpacerProps): ReactElement => (
  <PdfTextBlock
    content=' '
    viewStyle={{
      height,
    }}
    {...textBlockProps}
  />
);
